import {
  Card,
  Col,
  Row,
  Statistic,
  Tooltip,
  Empty,
  message,
  Avatar,
  Tabs,
  Table,
  Divider,
  Input,
  Button,
  Radio,
  Modal,
} from "antd";
import React, { Component, useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import styles from "./style.module.less";
import * as apis from "@/apis";
import { connect, useSelector } from "react-redux";
import dayjs from 'dayjs'
import copy from 'copy-to-clipboard';
import { getCurrentUser } from '@/models/user/selectors';

function getRedirectUrl() {
  const FINAL_REDIRECT_URL = encodeURIComponent(
    `https://${process.env.APP_MODE}.xiaobingsubang.com/qr_connect_callback_frame`
  );
  const AUTH_REDIRECT_URL = encodeURIComponent(
    `https://api.xiaobingsubang.com/auth/wechat/bindcall?open=1&r=tenant&redirect=${FINAL_REDIRECT_URL}`
  );

  return AUTH_REDIRECT_URL;
}
let locked = false

const InvitationPromotion = () => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [basicInfo, setBasicInfo] = useState({});
  const [visibleWeChatAuth, seVisibleWeChatAuth] = useState(false);
  const [settlementLoading, setSettlementLoading] = useState(false);

  const user = useSelector(getCurrentUser);

  const columns = [
    {
      title: '企业',
      // width: 200,
      key: 'tenant',
      dataIndex: 'tenant',
      render: (text, item) => {
        return item?.tenant?.short_name || ''
      }
    },
    {
      title: '结算方式',
      key: 'type',
      dataIndex: 'type',
      render: (text, item) => {
        return '每单' + (item.type == 1 ? item.per_order_commission + "元" : '毛利' + item.per_order_commission_rate * 100 + '%')

      }
    },
    {
      title: '享佣起始',
      // width: 160,
      align: 'center',
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: (text, item) => {
        return item?.createdAt ? dayjs(item?.createdAt).format('YYYY-MM-DD HH:mm') : ''
      }
    },
    {
      title: '享佣结束',
      align: 'center',
      key: 'lastBrokerageAt',
      dataIndex: 'lastBrokerageAt',
      render: (text, item) => {
        return item?.lastBrokerageAt ? dayjs(item?.lastBrokerageAt).format('YYYY-MM-DD HH:mm') : '无期限'
      }
    },
    {
      title: '月均订单',
      align: 'center',
      key: 'avgOrder',
      dataIndex: 'avgOrder',
    },
    {
      title: '之前月份未结算',
      align: 'center',
      key: 'no_amount',
      dataIndex: 'no_amount',
      render: (text, item) => {
        return item?.no_amount?.toFixed(2)
      }
    },
    {
      title: '本月佣金',
      align: 'center',
      key: 'amount',
      dataIndex: 'amount',
      render: (text, item) => {
        return item?.amount?.toFixed(2)
      }
    },
    // {
    //   title: '操作',
    //   // fixed: 'right',
    //   // width: 200,
    //   render: item => {
    //     return (
    //       <div>
    //         <a onClick={() => { }}>明细</a>

    //       </div>
    //     )
    //   }
    // }
  ]
  const columns2 = [
    {
      title: '类型',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: '结算日期',
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: (text, item) => {
        return item?.createdAt ? dayjs(item?.createdAt).format('YYYY-MM-DD HH:mm') : ''
      }
    },
    {
      title: '结算金额',
      key: 'amount',
      dataIndex: 'amount',
    },
  ]
  const fetchList = useCallback((params = {}) => {
    // params.offset = params.offset || offset
    // params.limit = params.limit || limit
    // setLimit(params.limit)
    // setOffset(params.offset)
    setLoading(true)

    apis
      .queryReferralInvite(params)
      .then((data) => {
        setBasicInfo(data || {})
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [])
  // const handleTableChange = (pagination, filters, sorter) => {
  //   const nextQuery = {
  //     ...filters,
  //     offset: (pagination.current - 1) * pagination.pageSize
  //   }
  //   if (sorter && sorter.field) {
  //     nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
  //   }
  //   fetchList(nextQuery)
  // }

  const settlementHandler = async () => {
    if (locked) {
      return false;
    }
    const date = new Date()
    // if (date.getDate() < 8) {
    //   message.error('每个月的第7日以后才能结算上月佣金');
    //   return
    // }

    locked = true; // 防止重复支付！
    setSettlementLoading(true);

    apis
      .referralSettlement(basicInfo?.referralId, { orderIds: basicInfo?.orderIds || [] })
      .then(() => {
        message.success('已结算');
        fetch();
      })
      .catch((err) => {
        message.error(err.message || '结算失败');
      })
      .finally(() => {
        setSettlementLoading(false);
        locked = false;
      });
  }

  const tknCallbackListener = useCallback((event) => {
    try {
      const [key, token] = event.data.split(':');
      if (
        event.origin === `https://${process.env.APP_MODE}.xiaobingsubang.com` &&
        key === 'tkn' &&
        token
      ) {
        localStorage.setItem(`xb_${process.env.APP_MODE}_token`, token);
        window.location.reload();
      }
    } catch (e) { }
  }, []);

  const handleWeChatAuth = () => {
    destroyWxLogin()
    seVisibleWeChatAuth(true)
  }

  const initWxLogin = () => {
    window.addEventListener('message', tknCallbackListener, false);
    let url = getRedirectUrl();
    console.log(url)
    const requestId = process.env.APP_MODE + user.get('_id');
    new window.WxLogin({
      self_redirect: true,
      id: 'login_container',
      appid: 'wx0ed51ad5722614d4',
      scope: 'snsapi_login',
      redirect_uri: url,
      state: requestId,
      style: 'black',
      href:
        (process.env.PUBLIC_URL || window.location.origin) +
        '/login_frame_overwrite.css',
    });
  }
  const destroyWxLogin = () => {
    window.removeEventListener('message', tknCallbackListener, false);
  }

  useEffect(() => {
    fetchList()
    return () => {
      destroyWxLogin()
    }
  }, [])

  useEffect(() => {
    if (visibleWeChatAuth) {
      setTimeout(() => {
        initWxLogin()
      }, 600);
    }

  }, [visibleWeChatAuth])

  return (
    <>
      <div className={styles.blockstyle}>
        <div className={styles.blocktitle}>推广邀请</div>
        <Row gutter={[10, 10]}>
          <Col span={6}>
            <Card bordered={false}>
              <Statistic title="我的邀请码"
                // value={basicInfo.referCode || ''}
                formatter={(value) => {
                  let str = ''
                  if (user.get('wechat') && Object.keys(user.get('wechat'))?.length > 0) {
                    str = basicInfo.referCode || ''
                  }
                  return str
                }}
                suffix={basicInfo.referCode && (user.get('wechat') && Object.keys(user.get('wechat'))?.length > 0) ?
                  <Button type="primary" size="small" ghost onClick={() => {
                    copy(basicInfo.referCode);
                    message.success("复制成功")
                  }}>复制</Button> :
                  <Button type="primary" size="small" ghost onClick={() => {
                    handleWeChatAuth()
                  }}>微信认证</Button>
                } />
            </Card>
          </Col>
          <Col span={6}>
            <Card bordered={false}>
              <Statistic title="已邀请商家数量" value={basicInfo?.refs?.length || 0} />
            </Card>
          </Col>
          <Col span={6}>
            <Card bordered={false}>
              <Statistic title="可结算总金额（元）" value={basicInfo.amount} />
            </Card>
          </Col>
          <Col span={6}>
            <Card bordered={false}>
              <Row gutter={[10, 10]} type="flex">
                <Col >
                  <Button
                    disabled={!basicInfo.amount}
                    size="large"
                    type="primary"
                    loading={settlementLoading}
                    onClick={settlementHandler}
                  >
                    结算
                  </Button>
                </Col>
                <Col flex={1}>
                  <div className={styles.tips}>
                    <div>* 每月8日可结算之前月份佣金</div>
                    <div>* 结算后不可撤回，请谨慎操作</div>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
      <div className={styles.blockstyle}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="已邀请入驻商家" key="1">
            <Table
              rowKey="_id"
              size="middle"
              columns={columns}
              dataSource={basicInfo?.refs || []}
              // onChange={handleTableChange}
              loading={loading}
              scroll={{ x: '100%' }}
            // pagination={{
            //   showQuickJumper: true,
            //   total: total,
            //   pageSize: +limit,
            //   current: Math.floor(offset / +limit) + 1,
            //   showTotal: total => `共 ${total} 条`
            // }}
            ></Table>
          </Tabs.TabPane>
          <Tabs.TabPane tab="账单" key="2">
            <Table
              rowKey="_id"
              size="middle"
              columns={columns2}
              dataSource={basicInfo?.settlements || []}
              // onChange={handleTableChange}
              loading={loading}
              scroll={{ x: '100%' }}
              // pagination={{
              //   showQuickJumper: true,
              //   total: total,
              //   pageSize: +limit,
              //   current: Math.floor(offset / +limit) + 1,
              //   showTotal: total => `共 ${total} 条`
              // }}
              expandedRowRender={(record, index, indent, expanded) => {
                if (!expanded) {
                  return null;
                }
                return (
                  <div>
                    {Object.keys(record?.tenant_list)?.map((item) => {
                      return (
                        <div key={item}>
                          <span style={{ marginRight: 20 }}>企业名称：{record?.tenant_list[item]?.short_name}</span>
                          <span>工单数量：{record?.tenant_list[item]?.number || 0}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              }}
            ></Table>
          </Tabs.TabPane>

        </Tabs>
      </div>

      <Modal
        title="微信认证"
        visible={visibleWeChatAuth}
        onOk={() => {
          seVisibleWeChatAuth(false)
          destroyWxLogin()
        }}
        onCancel={() => {
          seVisibleWeChatAuth(false)
          destroyWxLogin()
        }}
        okText="已认证"
      >
        <div id="login_container" className={styles.code}>
        </div>
      </Modal>
    </>
  );

}

export default connect()(InvitationPromotion);
